
/* eslint-disable max-len */

export default `
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="stroke" d="M19 22L19 25.1667C19 25.9741 18.5145 26.7023 17.7692 27.0128L15.7692 27.8462C14.4519 28.3951 13 27.4272 13 26V17.8195C13 17.2944 12.7934 16.7903 12.4249 16.4161L5.57509 9.46144C5.20656 9.08728 5 8.58318 5 8.05801V5C5 3.89543 5.89543 3 7 3H25C26.1046 3 27 3.89543 27 5L27 8"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path class="stroke" d="M26.02 18.02L20.02 12.02"  stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <path class="stroke" d="M26.02 12.02L20.02 18.02"  stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`
